import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { checkAuth } from './authSlice';

export const fetchDictionaties = createAsyncThunk(
    'catalogs/fetchDictionaties',
    async function (_, { rejectWithValue, getState, dispatch }) {
        try {
            const { user } = getState().auth;
            //console.log(user.accessToken)
            await dispatch(checkAuth(user));
            //console.log(getState().auth);
            //console.log(getState().auth);

            const response = await fetch('/api/v1/dictionaries', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${user.accessToken}`,
                    },
                });

            if (!response.ok) {
                throw new Error('Server Error!');
            }

            const data = await response.json();
            //console.log("Data", data);
            //localStorage.removeItem("banners_auth_data");
            return data;
        } catch (error) {
            console.log("ERROR", error);
            return rejectWithValue(error.message);
        }
    }
);

export const catalogSlice = createSlice({
    name: 'catalogs',
    initialState: {
        languages: [],
        countries: [],
        disciplines: [],
        sports: [],
        sportEvents: [],
        prospectTypes: [],
        eventTypes: [],
        cancelationStatuses: [],
        tournaments: [],
        isLoading: false,
        error: null
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDictionaties.fulfilled, (state, action) => {
                const { languages, countries, disciplines, sports, tournaments, sportEvents, prospectTypes, eventTypes, cancelationStatuses } = action.payload;
                
                state.languages = languages;
                state.countries = countries;
                state.disciplines = disciplines;
                state.sports = sports;
                state.sportEvents = sportEvents;
                state.prospectTypes = prospectTypes;
                state.eventTypes = eventTypes;
                state.cancelationStatuses = cancelationStatuses;
                state.tournaments = tournaments;
            })
            .addMatcher(isError, (state, action) => {
                state.error = action.payload;
                state.isLoading = false;
            })
            .addMatcher(isPending, (state) => {
                state.error = null;
                state.isLoading = true;
            })
            .addMatcher(isFulfilled, (state) => {
                state.isLoading = false;
            });
    }
})

// Action creators are generated for each case reducer function
export const { } = catalogSlice.actions

export default catalogSlice.reducer

function isError(action) {
    return action.type.endsWith('rejected') && action.type.startsWith('catalogs');
};

function isPending(action) {
    return action.type.endsWith('pending') && action.type.startsWith('catalogs');
};

function isFulfilled(action) {
    return action.type.endsWith('fulfilled') && action.type.startsWith('catalogs');
};